import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Card,
  CardContent,
} from '@material-ui/core';

export default function EventSearchBar({
  filters,
  years,
  eventTypes,
  areas,
  tags,
  onChange,
  onSearch,
}) {
  return (
    <Box mb={3}>
      <Card elevation={3} style={{ paddingTop: 10 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">

            {/* YEAR */}
            <Grid item xs={12} sm={2}>
              <TextField
                select
                label="ปี"
                variant="outlined"
                value={filters.year}
                onChange={(e) => onChange('year', e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (value) => (value === '' ? 'ทั้งหมด' : value),
                }}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                {years.map((y) => (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* EVENT TYPE */}
            <Grid item xs={12} sm={2}>
              <TextField
                select
                label="ประเภทเหตุการณ์"
                variant="outlined"
                value={filters.event_type}
                onChange={(e) => onChange('event_type', e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (value) => {
                    if (value === '') return 'ทั้งหมด';
                    const found = eventTypes.find((t) => t.value === value);
                    return found ? found.label : value;
                  },
                }}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                {eventTypes.map((t) => (
                  <MenuItem key={t.value} value={t.value}>
                    {t.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* AREA */}
            <Grid item xs={12} sm={2}>
              <TextField
                select
                label="พื้นที่ (จังหวัด)"
                variant="outlined"
                value={filters.area}
                onChange={(e) => onChange('area', e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (value) => {
                    if (value === '') return 'ทั้งหมด';
                    const found = areas.find(
                      (a) => a.province_code === value,
                    );
                    return found ? found.label : value;
                  },
                }}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                {areas.map((a) => (
                  <MenuItem
                    key={`${a.province_code}-${a.label}`}
                    value={a.province_code}
                  >
                    {a.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* TAGS */}
            <Grid item xs={12} sm={2}>
              <TextField
                select
                label="แท็ก"
                variant="outlined"
                value={filters.tag}
                onChange={(e) => onChange('tag', e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (value) => {
                    if (value === '') return 'ทั้งหมด';
                    const found = tags.find((t) => t.value === value);
                    return found ? found.name : value;
                  },
                }}
              >
                <MenuItem value="">ทั้งหมด</MenuItem>
                {tags.map((tag) => (
                  <MenuItem key={tag.value} value={tag.value}>
                    {tag.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* KEYWORD */}
            <Grid item xs={12} sm>
              <TextField
                label="ค้นหา"
                placeholder="เช่น น้ำท่วม"
                variant="outlined"
                value={filters.keyword}
                onChange={(e) => onChange('keyword', e.target.value)}
                fullWidth
              />
            </Grid>

            {/* BUTTON */}
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                style={{ height: 56 }}
                onClick={onSearch}
              >
                ค้นหา
              </Button>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

/* ✅ PropTypes (แก้ eslint react/prop-types) */
EventSearchBar.propTypes = {
  filters: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    event_type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    area: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tag: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    keyword: PropTypes.string,
  }).isRequired,

  years: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ).isRequired,

  eventTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,

  areas: PropTypes.arrayOf(
    PropTypes.shape({
      province_code: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,

  tags: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,

  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};
